import android from './android';
import brave from './brave';
import chrome from './chrome';
import edge from './edge';
import firefox from './firefox';
import ios from './ios';
import website from './website';

export const browsers = {
  brave,
  chrome,
  edge,
  firefox,
  android,
  ios,
  website,
};

export enum BrowserType {
  Brave = 'brave',
  Chrome = 'chrome',
  Edge = 'edge',
  Firefox = 'firefox',
  Android = 'android',
  Ios = 'ios',
  Website = 'website',
}

export const getBrowserIcon = (browser: BrowserType) => {
  return browsers[browser] || website;
};
